import React from "react";
import CustomInput from "./CustomInput";
import ModernDateInput from "./ModernDateInput";
import { useTranslation } from "react-i18next";

const VaccineInput = ({ ele, handleBlur, handleChange, values, disabled, modernDates }) => {
  const { t } = useTranslation();
  return (
    <div key={ele[0].name} className="child-register-repeat-block">
      <div className="child-register-repeat-header">
        <p
          style={{
            marginBottom: "0px",
            marginRight: "10px",
            fontSize: "14px",
            fontWeight: "bold",
          }}>
          {ele[0].name === "siblingName" ? t("Sibling Details") : t("Vaccination Details")}
        </p>
        {disabled ? null : (
          <button
            type="button"
            style={{ border: "none", backgroundColor: "transparent" }}
            onClick={() => handleChange({ target: { id: ele[0].name } }, null, "add")}>
            <i className="fas fa-plus fa-sm"></i>
          </button>
        )}
      </div>
      <div className="child-register-repeat-list">
        {values[ele[0].name]
          ? values[ele[0].name].map((_, index) => (
            <div className="child-register-repeat-row child-register-repeat-row-paired" key={index} >
              <CustomInput
                name={ele[0].name}
                label={ele[0].label}
                value={values[ele[0].name][index]}
                onChange={(event) => handleChange(event, index, "change")}
                onBlur={handleBlur}
                required={ele[0].required}
                type={"text"}
                disabled={disabled}
              />
              {modernDates && ele[1].type === "date" ? (
                <ModernDateInput
                  name={ele[1].name}
                  label={ele[1].label}
                  value={values[ele[1].name][index]}
                  onChange={(event) => handleChange(event, index, "change")}
                  onBlur={handleBlur}
                  required={ele[1].required}
                  disabled={disabled}
                />
              ) : (
                <CustomInput
                  name={ele[1].name}
                  label={ele[1].label}
                  value={values[ele[1].name][index]}
                  onChange={(event) => handleChange(event, index, "change")}
                  onBlur={handleBlur}
                  required={ele[1].required}
                  type={ele[1].type}
                  disabled={disabled}
                />
              )}
              <button
                type="button"
                disabled={disabled}
                onClick={() => handleChange({ target: { id: ele[0].name } }, index, "remove")}
                className="child-register-remove-row">
                <i className="fas fa-trash-alt fa-lg"></i>
              </button>
            </div>
          ))
          : null}
      </div>
    </div>
  );
};

export default VaccineInput;
